import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import "./TransitionsModal.css"; // Import a CSS file for custom scrollbar styles

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "35%", // Adjusted width for responsiveness
    bgcolor: "#fff", // Changed to a valid background color
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)", // Adjusted box shadow like login page
    padding: 4,
    maxHeight: "95vh",
    overflow: "auto",
    borderRadius: "10px",
};

export default function TransitionsModal({ children, open, setOpen, title }) {
    const handleClose = () => setOpen(false);

    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <Box
                        sx={{
                            ...style,
                            width: {
                                xs: "90%",
                                md: "35%",
                            },
                            borderRadius: 2,
                        }}
                    >
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mb={2}
                        >
                            <Typography
                                id="transition-modal-title"
                                variant="h6"
                                component="h2"
                                fontWeight="bold"
                            >
                                {title}
                            </Typography>
                            <IconButton
                                onClick={handleClose}
                                sx={{
                                    color: "red",
                                    padding: "4px",
                                    "&:hover": {
                                        backgroundColor: "rgba(0, 0, 0, 0.04)",
                                    },
                                }}
                            >
                                <Close fontSize="small" />
                            </IconButton>
                        </Box>
                        <Box>{children}</Box>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}
